import { render, staticRenderFns } from "./TrendHeader.vue?vue&type=template&id=e7eb45c4&name=trend-header&"
import script from "./TrendHeader.vue?vue&type=script&lang=js&"
export * from "./TrendHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports